export const ROUTES = {
  companyLocationUpdateRoute: 'company-location',
  upgradePlanRoute: 'upgrade-plan',
  dashboardRoute: 'dashboard',
  talentSearch: 'talent-search',
  onboarding: 'onboarding',
  logout: 'logout',
  companyReportStatus: 'company-report-status',
  emailVerification: 'email-verification',
  jobEnhance: 'job/enhance',
  manageCandidates: 'candidates',
  recommendedTalents: 'recommended-talents',
  messages: 'messages',
  features: 'features',
  featuresHistory: 'features/history',
  featuresOrderHistory: 'features/order-history',
  featuresCreditHistory: 'features/credit-history',
  login: 'login',
  signup: 'signup',
  forgotPassword: 'forgot-password',
  jobMetrics: 'job-metrics',
  applicationHistory: 'candidates/application-history',
  settings: 'settings',
  templateMessages: 'settings/templateMessages',
  hire: 'hire',
  jobs: 'jobs',
};
